<form class="card">
    @if (navigatingToArea) {
        <unity-loading-indicator [display]="UnityLoadingIndicatorDisplayEnum.Overlay" />
    }
    <h3>Choose an Area</h3>
    <select name="areaSelect" [(ngModel)]="selectedArea" class="form-select mt-2" (ngModelChange)="areaSelected()"
        [disabled]="filteredAreas?.length === 0 || navigatingToArea">
        <option *ngFor="let area of filteredAreas" [ngValue]="area">{{area.Alias || area.Name}}</option>
    </select>
    <button unity-button *sm-has-not-env-flag="'auroraV1'" 
            name="SelectAreaButton"
            [disabled]="filteredAreas?.length === 0 || navigatingToArea"
            (click)="areaSelect()"
            class="primary block mt-2">
        Go
    </button>
    <aurora-button block *sm-has-env-flag="'auroraV1'" 
            name="SelectAreaButton"
            [disabled]="filteredAreas?.length === 0 || navigatingToArea"
            (click)="areaSelect()"
            variant="primary"
            class="mt-3">
        Go
    </aurora-button>
    @if (isModal) {
        <button *sm-has-not-env-flag="'auroraV1'" 
            unity-button
            (click)="onCancel.emit()"
            class="ghost block on_dark mt-2">
            Cancel
        </button>
        <aurora-link-button *sm-has-env-flag="'auroraV1'" 
            (click)="onCancel.emit()"
            block
            class="mt-3 justify-content-center">
            Cancel
        </aurora-link-button>
    }
    
    <ng-container *ngIf="!isModal">
        <ng-container *sm-has-not-env-flag="'auroraV1'">
             <button unity-button
                *sm-has-any-permission="[
                    TENANT_PERMISSIONS.Common_SystemAccess,
                    TENANT_PERMISSIONS.Common_Tenant,
                    TENANT_PERMISSIONS.Common_Programs
                ]"
                class="link on_dark block mt-3"
                (click)="goToConfig()">
                Go to Configure
            </button>
        </ng-container>
        <aurora-link-button *sm-has-env-flag="'auroraV1'" 
            block
            class="mt-3 justify-content-center"
            (click)="goToConfig()">
                Go to Configure
        </aurora-link-button>
    </ng-container>
</form>
